'use client';

import { FC } from 'react';
import { openHintBottomSheet } from '@/common/components/Hint';
import { classnames } from '@/utils/classnames';
import TopMenuIcon from './TopMenuIcon';
import UserDetail from './UserDetails';

const TopHeader: FC = () => {
  const toggleStoryContainerShow = () => {
    openHintBottomSheet({ shouldOpenFullPage: false });
  };

  return (
    <header
      className={classnames(
        'flex h-[88px] flex-col transition-all duration-1000'
      )}
    >
      <div
        className={classnames(
          'flex flex-row items-center justify-between overflow-hidden px-5 py-4'
        )}
      >
        <UserDetail />
        <TopMenuIcon className="md:hidden" onClick={toggleStoryContainerShow} />
      </div>
    </header>
  );
};

export default TopHeader;
